import React from 'react';
function HackDay() {
    return (
      <div className="Hacktually" id="hacktually">
        <h2 className ="Hacktually-title"></h2>
        <div className="Hacktually-Grid">
          <div className="Hacktually-info">HacktoberFest HackDay is a mini, 12-hour hackathon. Participants will compete by making a project. Attend workshops, win prizes, and eat food!</div>
          <div className="Hacktually-info">Saturday October 24th 10:00am - 10:00pm, at UC Merced COB2 110.</div>
          <div className="Hacktually-info"><a href="https://events.mlh.com/events/14970-hacktoberfest-hack-day-merced-x-hackmerced?utm_source=ig&utm_medium=social&utm_content=link_in_bio" target="_blank" rel="noopener noreferrer">Sign up now!</a></div>
          <div className="Hacktually-info">Join our <a href="https://discord.gg/ShRCuvHcYk" target="_blank" rel="noopener noreferrer">Discord</a> to stay up to date</div>
        </div>
      </div>
    );
  }
  
  export default HackDay;